import { Component, Input, OnInit } from '@angular/core';
import { TicketReservationPlugin } from 'projects/qcloud-models/reservation-plugin/ticket-reservation-plugin';
import { ReservationQuestionType } from 'projects/qcloud-models/reservation/reservation-question-type.enum';
import { ReservationPluginService } from '../../services/reservation-plugin.service';

@Component({
  selector: 'app-reservation-confirm',
  templateUrl: './reservation-confirm.component.html',
  styleUrls: ['./reservation-confirm.component.scss']
})
export class ReservationConfirmComponent implements OnInit {

  @Input() ticketReservation: TicketReservationPlugin;
  categoryName: string;
  displayReservationTime: Date;

  constructor(public service: ReservationPluginService) {
  }

  ngOnInit(): void {
    this.displayReservationTime = new Date(this.ticketReservation.reservationTime.getFullYear(),
      this.ticketReservation.reservationTime.getMonth(),this.ticketReservation.reservationTime.getDate(),
      this.ticketReservation.reservationTime.getUTCHours(),this.ticketReservation.reservationTime.getMinutes());
    
    this.categoryName =
      this.ticketReservation.additionalReservationData.find(x => x.questionType == ReservationQuestionType.Case).answer;
  }

  refresh() {
    window.location.reload();
  }

}
